import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCodeXml = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "m18 16 4-4-4-4" }),
		/* @__PURE__ */ _jsx("path", { d: "m6 8-4 4 4 4" }),
		/* @__PURE__ */ _jsx("path", { d: "m14.5 4-5 16" })
	]
});
export default SvgCodeXml;
